import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class HourlyCarPriceService {


  static gethourlyCarCharges(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.gethourlyCarCharges}?id=${item?.id}`
      }
       else{
      api = `${API_BASE_URL}${API_PATHS.gethourlyCarCharges}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }




  
static addhourlyCarCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addhourlyCarCharges}`;
    return axiosInstance
        .post(api,item)
        
}

static edithourlyCarCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.edithourlyCarCharges}`;
    return axiosInstance
        .put(api,item)
        
}

static deletehourlyCarCharges(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletehourlyCarCharges}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletehourlyCarCharges}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default HourlyCarPriceService;